import React from 'react';
import { Link } from 'react-router-dom';
import { getAttribution } from '../firebase/referrals';
import { useAuth } from '../contexts/AuthContext';

export default function ReferralReminder() {
  const { user } = useAuth();
  if (!user || !getAttribution()) return null;
  return <aside className="mx-4 my-3 rounded-xl border border-accent-purple/25 bg-accent-purple/5 px-4 py-3 text-sm text-text-secondary">Your community invitation is saved. <Link to="/earn-rewards#your-circle" className="font-semibold text-accent-purple">Review the referral terms and finish joining →</Link></aside>;
}
